if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        const idInput = this.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        const submitBtn = this.querySelector('button[type=submit]');
        if (submitBtn) submitBtn.addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonFixed = this.querySelector('.stickyAddToCart[type="submit"]') || null;
      if (document.querySelector('cart-drawer') && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    getBundleSelectedVariantId() {
      const upsellVariantsJson = document.querySelector("#bundle-variants-json");

      if (!upsellVariantsJson) {
        return;
      }
      const upsellVariants = JSON.parse(upsellVariantsJson.textContent);
      
      const selectedRadios = document.querySelectorAll(
        "#bundle-product input[type='radio']:checked"
      );
      if(selectedRadios.length == 0){
        return;
      }
      
      const selectedOptions = Array.from(selectedRadios).map(
        (radio) => radio.value
      );
  
      const matchingVariant = upsellVariants.find((variant) =>
        selectedOptions.every(
          (option, index) => variant.options[index] === option
        )
      );
  
      if (!matchingVariant) {
        return;
      }
    
      return {
        id: matchingVariant.id,
        title: matchingVariant.title,
      };
    }
    
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;
      if (this.submitButtonFixed?.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      // Update buttons to loading state
      this.updateButtonState(this.submitButton, 'loading');
      this.updateButtonState(this.submitButtonFixed, 'loading');

      // Show loading spinners
      this.toggleSpinner(this.submitButton, true);
      this.toggleSpinner(this.submitButtonFixed, true);

      // Ensure fetchConfig and routes are defined
      if (typeof fetchConfig !== 'function' || !routes || !routes.cart_add_url) {
        console.error('Required functions or variables are not defined.');
        this.handleErrorMessage('Configuration error. Please try again later.');
        this.resetButtons();
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // delete config.headers['Content-Type'];
      config.headers['Content-Type'] = 'application/json';

      const mainProductId = parseInt(this.form?.querySelector('[name=id]')?.value);
      const mainProductQuantity = parseInt(this.form?.querySelector('[name=quantity]')?.value);
      const bundleVariant = this.getBundleSelectedVariantId();
      // console.log('bundleVariant',bundleVariant)
      
      let items;
      let bundleGroup;
      if (bundleVariant) {
        bundleGroup = `bundle-${bundleVariant.id}`; 
        items = [
          { 
            id: mainProductId,
            quantity: mainProductQuantity,
            properties: { '_bundleId' : bundleGroup, 'Delivery': bundleVariant.title, '_sub_variant_id' : `${bundleVariant.id}` }
          }
        ];
    
        items.push({ id: bundleVariant.id, quantity: mainProductQuantity, properties: { '_bundleId' : bundleGroup } });
      }else{
        items = [
          { 
            id: mainProductId,
            quantity: mainProductQuantity
          }
        ];
      }
      const formData = { items };
      
      /* if (this.form) {
        formData = new FormData(this.form);
      } else {
        formData = new FormData();
        const idValue = this.querySelector('[name=id]')?.value;
        if (idValue) {
          formData.append('id', idValue);
        } else {
          console.error('Product ID not found.');
          this.handleErrorMessage('Product information is missing.');
          this.resetButtons();
          return;
        }
      }

      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }
      config.body = formData; */

       if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
      
      config.body = JSON.stringify(formData);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: items.map((item) => item.id),
                errors: response.description,
                message: response.message
              });
            }
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
            if (!soldOutMessage) {
              console.warn('Sold out message element not found.');
              this.resetButtons();
              return;
            }

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span')?.classList.add('hidden');

            if (this.submitButtonFixed) {
              this.submitButtonFixed.setAttribute('aria-disabled', true);
              this.submitButtonFixed.querySelector('span')?.classList.add('hidden');
            }
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error && typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: items.map((item) => item.id)
            });
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            }, { once: true });
            if (typeof quickAddModal.hide === 'function') {
              quickAddModal.hide(true);
            }
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((error) => {
          console.error('Fetch error:', error);
          this.handleErrorMessage('An unexpected error occurred. Please try again later.');
        })
        .finally(() => {
          this.resetButtons();
        });
    }

    updateButtonState(button, state) {
      if (!button) return;
      if (state === 'loading') {
        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');
      } else if (state === 'reset') {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
    }

    toggleSpinner(button, show) {
      if (!button) return;
      const spinner = button.querySelector('.loading-overlay__spinner');
      if (!spinner) return;
      spinner.classList.toggle('hidden', !show);
    }

    resetButtons() {
      this.updateButtonState(this.submitButton, 'reset');
      this.updateButtonState(this.submitButtonFixed, 'reset');
      this.toggleSpinner(this.submitButton, false);
      this.toggleSpinner(this.submitButtonFixed, false);
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) {
        console.warn('Error message wrapper not found.');
        return;
      }
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      if (!this.errorMessage) {
        console.warn('Error message element not found.');
        return;
      }

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
